import { types } from "mobx-state-tree";
import type { Instance, SnapshotIn, SnapshotOut } from "mobx-state-tree";

export interface InsuranceCompanyInstance
  extends Instance<typeof InsuranceCompany> {}
export interface InsuranceCompanySnapshotIn
  extends SnapshotIn<typeof InsuranceCompany> {}
export interface InsuranceCompanySnapshotOut
  extends SnapshotOut<typeof InsuranceCompany> {}

export const InsuranceCompany = types.model("InsuranceCompany", {
  id: types.identifier,
  name: types.string,
});
